import { Component, Input, forwardRef } from '@angular/core';
import { PAYROLL_TYPES } from '../../../contants/PAYROLL_TYPES';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { AlertService } from '../../../services/alert.service';
import { ConfigurationService } from '../../../services/configuration.service';
import { KeyValuePair } from '../../../models/common/keyValuePair';

@Component({
	selector: 'payroll-type-select',
	templateUrl: './payroll-type-select.component.html',
	styleUrls: ['./payroll-type-select.component.css'],
	providers: [
		{
			provide: NG_VALUE_ACCESSOR,
			useExisting: forwardRef(() => PayrollTypeSelectComponent),
			multi: true
		}
	]
})
export class PayrollTypeSelectComponent implements ControlValueAccessor {
	types: KeyValuePair[] = [		
		{key: PAYROLL_TYPES.bookKeeper, value: 'Bookkeeper'},
		{key: PAYROLL_TYPES.driver, value: 'Driver'},
		{key: PAYROLL_TYPES.helper, value: 'Helper'},
		{key: PAYROLL_TYPES.maintenance, value: 'Maintenanace'}
	];

	@Input('value') _value: string;
	@Input() isDisabled: boolean = false;

	onChange: any = () => { };
	onTouched: any = () => { };

	get value() {
		return this._value;
	}

	set value(val) {
		this._value = val;
		this.onChange(val);
		this.onTouched();
	}

	constructor(
		private _configurationService: ConfigurationService,
		private _alertService: AlertService
	) { }

	writeValue(value): void {
		if (value !== undefined) {
			this._value = value;
		}
	}

	registerOnChange(fn: any): void {
		this.onChange = fn;
	}

	registerOnTouched(fn: any): void {
		this.onTouched = fn;
	}

	ngOnInit() {
		this._configurationService.getPayrollTypes().subscribe(response => {
			if (response.length != undefined && response.length > 0) {
				this.types = response;
				this.types.sort();
			}
			else {
				console.log('Unable to load payroll type selection.');
			}
		});
	}

}



// WEBPACK FOOTER //
// ./src/app/components/shared/payroll-type-select/payroll-type-select.component.ts